module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qdige5-8cae2ba0227b24e64c2967ee738c408d.jpg";